module.exports = __webpack_public_path__ + "static/media/trial3.826ea6e4.mp3";